import { createSelector } from 'reselect'
import { CommonState } from '~/store/types'

const selectTransactionStore = (state: CommonState) =>
  state.transactions || state.straitsXTransactions

export const selectLatestTransactions = createSelector([selectTransactionStore], state => {
  return state.latestPersonalTransactions || state.latestTransactions
})

export const selectIsTrxInfoFetched = createSelector(
  [selectTransactionStore],
  state =>
    state.isUserHasFiatDeposit !== null &&
    state.isUserHasStablecoinDeposit !== null &&
    state.isUserHasStablecoinWithdrawal !== null &&
    state.isUserHasFiatWithdrawal !== null
)
